
import React from 'react';
import { Newspaper } from 'lucide-react';
import NewsArticle from './NewsArticle';

const NewsSection = () => {
  const newsArticles = [
    {
      articleUrl: 'https://www.peoplematters.in/article/hr-technology/how-hr-tech-startup-cutshort-is-leveraging-ai-to-revolutionize-recruitment-23326',
      articleTitle: 'How HR Tech startup CutShort is leveraging AI to revolutionize recruitment'
    },
    {
      articleUrl: 'https://timesofindia.indiatimes.com/blogs/voices/challenges-the-recruiters-are-facing-from-the-new-form-of-hiring/',
      articleTitle: 'Challenges the recruiters are facing from the new form of hiring'
    },
    {
      articleUrl: 'https://thepeoplemanagement.com/challenges-the-tech-companies-are-facing-with-acceptance-rate-for-offer-letters-by-employees-nikunj-verma-co-founder-ceo-cutshort/',
      articleTitle: 'Challenges The Tech Companies Are Facing With Acceptance Rate'
    },
    {
      articleUrl: 'https://smefutures.com/how-has-deep-tech-hiring-transformed-since-the-pandemic/',
      articleTitle: 'How has deep tech hiring transformed since the pandemic?'
    },
    {
      articleUrl: 'https://www.cnbctv18.com/education/jobs-galore-as-hiring-trends-in-india-look-rosy-this-q3-report-15097101.htm',
      articleTitle: 'Jobs galore as hiring trends in India look rosy'
    }
  ];

  return (
    <div>
      <h4 className="font-semibold text-brand-darkgrey mb-4 flex items-center gap-1">
        <Newspaper className="h-4 w-4" />
        In the News
      </h4>
      <ul className="space-y-3">
        {newsArticles.map((article, index) => (
          <NewsArticle
            key={index}
            articleUrl={article.articleUrl}
            articleTitle={article.articleTitle}
          />
        ))}
      </ul>
    </div>
  );
};

export default NewsSection;
